import { QuotedIndicativeComponent } from 'components/common-form/sidePanel/status/quoted.indicative/Quoted.Indicative.status';
import type { StatusProps } from 'components/common-form/sidePanel/status/Status.connect';
import { FC } from 'react';
import type { WorkFlowStatus } from 'state/selectors';

import { Initialized } from './Initialized.status';
import { Ready } from './Ready.status';
import { SkeletonStatus } from './Skeleton.status';
import {
  InError,
  QuotedPreviously,
  QuotedTradable,
  QuoteRejected,
  Quoting,
  TradeDone,
  TradePending,
} from './status.common';

function componentForStatus(status: WorkFlowStatus) {
  switch (status) {
    case 'LOADING':
      return () => <SkeletonStatus color="secondary" />;

    case 'INITIALIZED':
      return Initialized;

    case 'READY':
      return Ready;

    case 'QUOTING':
      return Quoting;

    case 'QUOTED_PREVIOUSLY':
      return QuotedPreviously;

    case 'ERROR':
      return InError;

    case 'REJECTED':
      return QuoteRejected;

    case 'QUOTED':
      return QuotedIndicativeComponent;

    case 'QUOTED_TRADABLE':
      return QuotedTradable;

    case 'TRADING':
      return TradePending;

    case 'TRADED':
      return TradeDone;

    case 'TRADE_AUTH_REJECTED':
    case 'UNDEFINED':
      return null;

    default:
      throw new Error(`status ${status} is not supported `);
  }
}
export const StatusComponent: FC<StatusProps> = ({ tabId, status, workspaceType }) => {
  const Comp = componentForStatus(status);

  return (
    <div id="side-panel-status" data-e2e="side-panel-status">
      {Comp !== null && <Comp tabId={tabId} workspaceType={workspaceType} />}
    </div>
  );
};

StatusComponent.displayName = 'SidePanelStatus';
